<template>
<div class="icon">
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h40v40H0z"/>
        <g stroke="currentColor" stroke-linecap="round" stroke-width="3">
            <path d="M22.175 10l9.79 9.8-9.79 9.802M31.965 19.792H8"/>
        </g>
    </g>
</svg>

</div>
</template>

<script setup>
</script>
